var exports = {
  "HS": "VoiceE2EEIndicator.module__indicatorBase___SlQycX",
  "QS": "VoiceE2EEIndicator.module__indicatorEncrypted___SlQycX" + " " + "VoiceE2EEIndicator.module__indicatorBase___SlQycX",
  "pP": "VoiceE2EEIndicator.module__indicatorBroken___SlQycX" + " " + "VoiceE2EEIndicator.module__indicatorBase___SlQycX",
  "Gm": "VoiceE2EEIndicator.module__indicatorP2p___SlQycX" + " " + "VoiceE2EEIndicator.module__indicatorEncrypted___SlQycX" + " " + "VoiceE2EEIndicator.module__indicatorBase___SlQycX",
  "RQ": "VoiceE2EEIndicator.module__indicatorP2pBroken___SlQycX" + " " + "VoiceE2EEIndicator.module__indicatorBroken___SlQycX" + " " + "VoiceE2EEIndicator.module__indicatorBase___SlQycX",
};

module.exports = exports;
